import { getAuthorized } from "@/lib/fetch";

async function fetchToken() {
  const response = await getAuthorized(
    `${import.meta.env.VITE_BACKEND_URL}/tableau/token`,
  ).then((r) => r.json());
  return response;
}

export { fetchToken };
